// Races `promise` against a timer so a hung request surfaces instead of spinning forever. The
// source promise isn't cancellable — it keeps running after a timeout — so callers that act on
// its result must guard against a late resolution themselves.

export class TimeoutError extends Error {
	constructor(message = "Operation timed out") {
		super(message);
		this.name = "TimeoutError";
	}
}

export const withTimeout = <T>(promise: Promise<T>, ms: number): Promise<T> =>
	new Promise<T>((resolve, reject) => {
		const timer = setTimeout(() => reject(new TimeoutError(`Timed out after ${ms}ms`)), ms);
		promise.then(
			(value) => {
				clearTimeout(timer);
				resolve(value);
			},
			(error) => {
				clearTimeout(timer);
				reject(error);
			}
		);
	});

export default withTimeout;
